import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { CampaignPlacementsTable } from '../components/campaigns/CampaignPlacementsTable2'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { CampaignPlacement } from '../types/campaign'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const CampaignPlacements = observer(({}) => {
    const { profile } = useUser()
    const [store] = useState(new TableStore<CampaignPlacement>(userStore, `campaign_placements`))
    const savedFiltersStore = useSavedFiltersStore()

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/campaign-placements', params, true)
    }
    const tableHooks = useTableHooksFromStore(load, {}, true, store)

    return (
        <CampaignPlacementsTable
            store={store}
            savedFiltersStore={savedFiltersStore}
            tableHooks={tableHooks}
        />
    )
})
